import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import { useAppSelector } from "../../../../redux/hooks";
import { apiClient } from "../../../../zodios/client";

export const useGetV4AdvReportOptions = () => {
  const marketPlace = useAppSelector((state) => state.marketPlace.marketPlace);
  return queryOptions({
    queryKey: [{ entity: "V4AdvReportByAd", marketPlace }],
    queryFn: async () =>
      await apiClient.getV4AdvReportOptions({
        queries: {
          marketplace: marketPlace,
        },
      }),
    placeholderData: keepPreviousData,
  });
};
